import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Navigate } from "react-router-dom";
import { Row, Col, FormGroup, Input, Button, Label, Modal, ModalHeader, ModalBody, Card, CardBody } from "reactstrap";
import Services from "./services.js";
import AuthService from "../Authentication/auth.service.js";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import Alerts from "../../components/Alerts/alerts.js";
import PermissionAccess from '../../PermissionAccess/Access.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTimes, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const Preview = ({ file, onRemove }) => {
  if (!file) return null;

  const style = {
    position: 'absolute',
    top: '-160px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1000,
    // backgroundColor: 'white',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0,0,0,0.5)',
    maxWidth: '300px',
    maxHeight: '300px'
  };

  const removeButtonStyle = {
    position: 'absolute',
    top: '5px',
    right: '5px',
    zIndex: 1001,
    backgroundColor: 'red',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  };

  return (
    <div style={style}>
      {file.type === 'application/pdf' && (
        <>
          <button onClick={onRemove} style={removeButtonStyle}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <iframe src={URL.createObjectURL(file)} title="PDF Preview" width="280" height="280" />
        </>
      )
      }
    </div>
    // <div style={style}>
    //   <button onClick={onRemove} style={removeButtonStyle}>
    //     <FontAwesomeIcon icon={faTimes} />
    //   </button>
    //   {file.type.startsWith('image/') ? (
    //     <></>
    //     // <img src={URL.createObjectURL(file)} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />
    //   ) : file.type === 'application/pdf' ? (
    //     <iframe src={URL.createObjectURL(file)} title="PDF Preview" width="280" height="280" />
    //   ) : (
    //     <div>Unsupported file type</div>
    //   )}
    // </div>
  );
};

const AddBanner = ({ onSuccess }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [banners, setBanners] = useState([{ title: '', portal: '', order: '', startDate: '', endDate: '', Image: [] }]);
  const [loading, setLoading] = useState(false);
  const [loginNavigate, setLoginNavigate] = useState(false);
  const [Fetched_Businesses, setFetched_Businesses] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const modalRef = useRef(null);



  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    Fetch_Businesses();
  }, []);


  useEffect(() => {
    if (modalOpen) {
      loadGoogleMapsScript();
    }
  }, [modalOpen]);


  const loadGoogleMapsScript = () => {
    if (!window.google || !window.google.maps) {
      //iph todo: 47
      //console.log("Loading Google Maps script...");
      const script = Image.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDlKtLygdyr4XpjVE1WcyR7yHuigyq_agw&libraries=places`;
      script.async = true;
      script.onload = () => {
        //iph todo: 47
        //console.log("Google Maps script loaded. Initializing Autocomplete...");
        initAutocomplete();
      };
      Image.head.appendChild(script);
    } else {
      //iph todo: 47
      //console.log("Google Maps already loaded. Initializing Autocomplete...");
      initAutocomplete();
    }
  };

  const initAutocomplete = () => {
    if (!inputRef.current) {
      //iph todo: 47
      //console.log("Input ref not available. Autocomplete initialization delayed.");
      setTimeout(initAutocomplete, 100);
      return;
    }

    //iph todo: 47
    //console.log("Initializing Autocomplete...");
    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['endDate'],
    });

    autocompleteRef.current.addListener('place_changed', handlePlaceSelect);

    // Adjust the position of the autocomplete dropdown
    const pacContainer = document.querySelector('.pac-container');
    if (pacContainer) {
      pacContainer.style.zIndex = "1500"; // Ensure it's above the modal
      pacContainer.style.width = `${inputRef.current.offsetWidth}px`;
      pacContainer.style.left = `${inputRef.current.getBoundingClientRect().left}px`;
      pacContainer.style.top = `${inputRef.current.getBoundingClientRect().bottom}px`;
    }

    //iph todo: 47
    //console.log("Autocomplete initialized.");

    // Prevent form submission on enter
    inputRef.current.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') e.preventDefault();
    });
  };


  const handlePlaceSelect = () => {
    //iph todo: 47
    //console.log("Place selected. Updating endDate...");
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) {
      //iph todo: 47
      //console.error('No details available for input:', place.name);
      return;
    }

    const endDate = place.formatted_endDate;
    setBanners(prevBanners => prevBanners.map((Banner, i) =>
      i === 0 ? { ...Banner, endDate: endDate } : Banner
    ));
    //iph todo: 47
    //console.log("endDate updated:", endDate);
  };


  function Fetch_Businesses() {
    setLoading(true);
    Services.GetBusinesses(authData.sessionID).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          const business = response.data.data[0];
          setFetched_Businesses([business]);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      }
    );
  }



  const [previewFile, setPreviewFile] = useState(null);

  const handleFileChange = (index, event) => {
    const files = Array.from(event.target.files);
    setBanners(prevBanners => prevBanners.map((Banner, i) =>
      i === index ? { ...Banner, Image: [...Banner.Image, ...files] } : Banner
    ));
  };

  const removeImage = (BannerIndex, docIndex) => {
    setBanners(prevBanners => prevBanners.map((Banner, i) =>
      i === BannerIndex ?
        { ...Banner, Image: Banner.Image.filter((_, index) => index !== docIndex) }
        : Banner
    ));
    setPreviewFile(null);
  };


  const PreviewImage = (file) => {
    setPreviewImage(file);
    setPreviewModal(true);
  };

  const toggle = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setBanners([{ title: '', portal: '', order: '', startDate: '', endDate: '', Image: [] }]);
    }
  };


  const handleBannerChange = (index, field, value) => {
    setBanners(prevBanners => prevBanners.map((Banner, i) =>
      i === index ? { ...Banner, [field]: value } : Banner
    ));
  };

  const validateForm = () => {
    return banners.every(Banner =>
      Banner.title &&
      Banner.portal &&
      Banner.order &&
      Banner.startDate &&
      Banner.endDate &&
      Banner.Image.length > 0
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      Alerts.swalErrorAlert("Please fill all fields and upload at least one Image for banners.");
      return;
    }

    const formData = new FormData();

    // Append Banner data to formData
    Object.keys(banners[0]).forEach(key => {
      if (key === 'Image') {
        // Append each Image
        banners[0].Image.forEach((doc, index) => {
          formData.append(`Image`, doc);
        });
      } else {
        // Append other fields
        formData.append(key, banners[0][key]);
      }
    });

    formData.append('business_id', Fetched_Businesses[0]._id);
    formData.append('status', "Active");
    for (let [key, value] of formData.entries()) {
      //iph todo: 47
      //console.log(`${key}: ${value}`);
    }

    setLoading(true);
    try {
      const response = await Services.AddBanner(authData.sessionID, formData);
      setLoading(false);
      if (response.data.status) {
        onSuccess();
        Alerts.swalSuccessAlert(response.data.message || "Banner Added Successfully.").then(() => {
          toggle();
        });
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          setLoginNavigate(true);
        } else {
          Alerts.swalErrorAlert(response.data.message || "Error: Can't Add Banner at the moment. Please try again later.");
        }
      }
    } catch (error) {
      setLoading(false);
      Alerts.swalErrorAlert("Network Operation failed.");
    }
  };

  if (loginNavigate) {
    return <Navigate to={'/login'} />;
  }

  return (
    <span className="d-inline-block float-end mb-2 me-2">
      <Button color="success" onClick={toggle} className="btn-hover-shine ms-1">
        {t("Add New")}
      </Button>
      <Modal size='lg' isOpen={modalOpen} toggle={toggle} backdrop={true} ref={modalRef}>
        <LoadingOverlay active={loading} spinner={<DNALoader />}>
          <ModalHeader>{t("Add Banner")}</ModalHeader>
          <ModalBody>
            <Card className="main-card mb-3">
              <CardBody>
                <form onSubmit={handleSubmit}>
                  {banners.map((Banner, index) => (
                    <FormGroup key={index} className="mb-3">
                      <Row>
                        <Col md="6">
                          <Label>{t("Banner Title")}</Label>
                          <Input
                            type="text"
                            value={Banner.title}
                            onChange={(e) => handleBannerChange(index, 'title', e.target.value)}
                            placeholder={t("Enter Title")}
                          />
                        </Col>
                        <Col md="6">
                          <Label>{t("Order")}</Label>
                          <Input
                            type="order"
                            value={Banner.order}
                            onChange={(e) => handleBannerChange(index, 'order', e.target.value)}
                            placeholder={t("Enter Order")}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col md="6">
                          <Label>{t("Start Date")}</Label>
                          <Input
                            type="date"
                            value={Banner.startDate}
                            onChange={(e) => handleBannerChange(index, 'startDate', e.target.value)}
                            placeholder={t("Start Date")}
                          />
                        </Col>
                        <Col md="6">
                          <Label>{t("End Date")}</Label>
                          <div style={{ position: 'relative' }}>
                            <Input
                              type="date"
                              value={Banner.endDate}
                              onChange={(e) => handleBannerChange(index, 'endDate', e.target.value)}
                              placeholder={t("End Date")}
                              innerRef={inputRef}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col md="12">
                          <Label>{t("Portal")}</Label>
                          <Input
                            type="select"
                            value={Banner.portal}
                            onChange={(e) => handleBannerChange(index, 'portal', e.target.value)}
                          >
                            <option value="" disabled>{t("Select Portal")}</option> {/* Placeholder option */}
                            <option value="shop">{t("Shop")}</option>
                            <option value="doctors_portal">{t("Doctors Portal")}</option>
                            <option value="all">{t("ALL")}</option>
                          </Input>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col md="12">
                          <Label>{t("Image")}</Label>
                          <div className="Image-upload-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {Banner.Image.map((doc, docIndex) => (
                              <div
                                key={docIndex}
                                style={{ position: 'relative', width: '100px', height: '100px' }}
                                onMouseEnter={() => setPreviewFile(doc)}
                                onMouseLeave={() => setPreviewFile(null)}
                              >
                                {doc.type.startsWith('image/') ? (
                                  <img src={URL.createObjectURL(doc)} alt={`Image ${docIndex + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                    <FontAwesomeIcon icon={faFilePdf} size="2x" />
                                  </div>
                                )}
                                <Button
                                  color="danger"
                                  size="sm"
                                  style={{ position: 'absolute', top: '-10px', right: '-10px', borderRadius: '50%', padding: '0.2rem 0.5rem' }}
                                  onClick={() => removeImage(index, docIndex)}
                                >
                                  <FontAwesomeIcon icon={faTimes} />
                                </Button>
                                {previewFile === doc &&
                                  <Preview
                                    file={doc}
                                    onRemove={() => removeImage(index, docIndex)}
                                  />}
                              </div>
                            ))}
                            <div  style={{ width: '100px', height: '100px',  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                              <label htmlFor={`file-upload-${index}`} style={{ cursor: 'pointer', margin: 0 }}>
                                <FontAwesomeIcon icon={faUpload} size="2x" />
                                <Input
                                  type="file"
                                  id={`file-upload-${index}`}
                                  onChange={(e) => handleFileChange(index, e)}
                                  accept=".jpg,.jpeg,.png"
                                  multiple
                                  style={{ display: 'none' }}
                                />
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </FormGroup>
                  ))}
                  <div className="text-center">
                    <Button type="submit" color="success" size="lg" className="me-3">
                      {t("Save")}
                    </Button>
                    <Button type="button" color="secondary" size="lg" onClick={toggle}>
                      {t("Cancel")}
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </ModalBody>
        </LoadingOverlay>
      </Modal>
      <style>{`
        .pac-container {
          z-index: 1500 !important;
        }
      `}</style>
    </span>
  );
};

export default AddBanner;

